export default __webpack_public_path__ + "scene037854e9.jpg";